exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "\n", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"mixins.scss"}]);
// Exports
exports.locals = {
	"font-family": "'styleguideicons'",
	"font-size": "16px",
	"font-style": "normal",
	"font-weight": "normal",
	"line-height": "1",
	"text-transform": "none",
	"speak": "none",
	"-webkit-font-smoothing": "antialiased",
	"-moz-osx-font-smoothing": "grayscale"
};